import React, { FC, useEffect, useMemo, useState } from "react";
import { BackHandler, KeyboardAvoidingView, Platform, Pressable, ScrollView, TouchableOpacity, View, useWindowDimensions } from "react-native";
import { useIsFocused } from "@react-navigation/native";
import { ThemeConsumer } from "@rneui/themed";
import { useFormik } from "formik";
import * as Yup from 'yup'
import moment from "moment";
import Popover from "react-native-popover-view/dist/Popover";

import { config } from "../../../shared/environment";
import { API } from "../../../shared/apiRoutes";
import { appColors, appFonts, fontSize } from "../../../themes/appTheme";

import CommonHeader from "../../../shared/commonComponents/commonHeader";
import CommonDialogBox from "../../../shared/commonComponents/commonDialogBox";

import { getScreenPermission, useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { useAppNavigation, useAppRoute } from "../../../types/@react-navigation/navigation";
import { addPosDiscount, checkDuplicatesData, getCustomerEligibilityTypeData, getOnePosDiscountData, getPosDiscountTypes, getPosPropertyValueData, updatePosDiscount } from "../../../redux/slices/manualDiscountSlice";
import { RestrictionData, DiscountTypeData, DiscTypes, PropertyValueData, PropertyValues, DiscountData, confirmtionMessageProps, customerEligibilityData, DropDownData } from "./manualDiscountModule";

import { ZenButton, ZenCheckBox, ZenDateTimePicker, ZenDropdown, ZenIcon, ZenInput, ZenLoader, ZenRadioButton, ZenToast, ZenText, ZenToolTip } from "zen-core-elements";
import { shallowEqual } from "react-redux";
import { PayXGetFreeStyle } from "../../../themes/components/discounts/payXGetFreeStyle";

type eligibleCustomerDataType = Map<string, { value: { label: string; value: string | number; id: number; }[], name: string, code: string }>
//add/edit Manual discount functional component
const AddEditManual: FC = () => {
    const { isWrite } = useAppSelector(getScreenPermission("ManualDiscountStack"), shallowEqual);

    // used for mobile view
    const { isLandscape } = useAppSelector((state) => state?.common)
    //used to dispatch actions
    const dispatch = useAppDispatch()
    //variable to store the width of the screen
    const { width } = useWindowDimensions()
    //variable to store navigation from useNavigation hook
    const navigation = useAppNavigation()
    //variable which holds route params
    const { params } = useAppRoute("AddEditManual")
    //variable to hold the focused state from useIsfocused hook
    const isFocused = useIsFocused()
    //variable to track the loading status
    const [load, setLoad] = useState<boolean>(true)
    //variable to store the applicable items
    const [applicableTo, setApplicableTo] = useState<number>()
    //variable to store whether code already exists or not
    const [isExist, setIsExist] = useState<boolean>(false)
    //variable to store the restriction data
    const [restriction, setRestriction] = useState<RestrictionData[]>([])
    //variable to store the discount type data
    const [discountType, setDiscountType] = useState<DiscountTypeData[]>([])
    // Variable which is used to store typesOfEligibility value
    const [typesOfEligibility, setTypesOfEligibility] = useState<customerEligibilityData[] | any>([])
    //variable to store the single discount details
    const [discountData, setDiscountData] = useState<DiscountData | any>()
    //variable to open/close confirmation popover
    const [dirtyPopover, setDirtyPopover] = useState<boolean>(false)
    //variable to hold whether discount expired or not
    const [discountExpired, setDiscountExpired] = useState<boolean>(false)
    //variable to display discount expired popover
    const [expiredPopover, setExpiredPopover] = useState<boolean>(false)
    //variable to open/close dropdown
    const [dropdownOpen, setDropdownOpen] = useState<boolean>(false)
    //variable to set hold the current date
    const [mydate, setDate] = useState(new Date());
    //variable used to open/close date picker
    const [showDate, setShowDate] = useState<boolean>(false);
    // Variable which is used to open/close eligibility dropdown picker 
    const [eligibilityOpen, setEligibilityOpen] = useState<boolean>(false)
    // Variable which is used to open/close customergroup picker
    const [customerGroupOpen, setCustomerGroupOpen] = useState<boolean>(false)
    //variable to store the warning confirmation msg
    const [warningConfirmMessage, setWarningConfirmMessage] = useState<confirmtionMessageProps>()
    //Variable to set startDate
    const [startDateSelected, setStartDateSelected] = useState<boolean>(false)
    //VAriable to check whether the discount is available or not in data base
    const [isDiscountAvailable, setIsDiscountAvailable] = useState<boolean>(true)
    //variable to store the discount expired confirmation dialog
    const warningDialogProps = {
        content: 'The discount has expired. Kindly change the endDate to edit the discount',
        icon: { name: 'run', color: appColors.primary, type: 'material-community' }, button: [{ id: 1, name: "okay", color: appColors.primary, backgroundColor: appColors.light }],

    }
    const [isOptionChanged, setIsOptionChanged] = useState(false)
    const [eligibileCustomersArr, setEligibileCustomersArr] = useState<eligibleCustomerDataType>(new Map())

    //useEffect that gets trigerred when page gets focused
    useEffect(() => {
        if (isFocused) {
            setLoad(true);
            getDiscountTypes()
        }
    }, [isFocused])

    //useEffect which gets triggered when discount expires
    useEffect(() => {
        if (discountExpired) {
            setExpiredPopover(true)
        }
    }, [discountExpired])

    //useEffect to display display expired popover
    useEffect(() => {
        if (warningConfirmMessage?.name == "okay") {
            setExpiredPopover(false)
        }
    }, [warningConfirmMessage])



    //function used to handle confirmation popover
    const confirmation = (item: { id: number }) => {
        if (item?.id == 2) {
            setDirtyPopover(false)
            navigation.goBack()
        } else {
            setDirtyPopover(false)
        }
    }

    //function to fetch discount types
    const getDiscountTypes = () => {
        dispatch(getPosDiscountTypes({ storeId: config?.storeId })).unwrap().then((response) => {
            if (response && response?.discountTypes) {
                response?.discountTypes?.map((e: DiscTypes) => {
                    const discountTypeArr: DiscountTypeData[] = []
                    const uniqueDiscountType = Array.from(
                        new Map(([...response?.discountTypes]).map(item => [item?.id, item])).values()
                    );
                    uniqueDiscountType?.forEach((type: DiscTypes, index: number) => {
                        if (type) {
                            discountTypeArr.push({ code: type?.code, label: type?.discountName, value: type?.id })
                        }
                    })
                    setDiscountType(discountTypeArr)
                })
                getPropertyValues()
            }
        }).catch((err) => console.log('Error in getDiscountTypes', err))
    }

    //function to fetch property values
    const getPropertyValues = () => {
        const propertValues: string[] = ["RECCURRENCE", "APPLICABLE_CUSTOMERS", "APPLICABLE_ITEMS", "APPLICABLE_TO", "DISCOUNT_RESTRICTION_VALUES", "DISCOUNT_CONDITIONAL_TYPE"]
        const payloadProps = { storeId: config?.storeId, propertyValues: propertValues }
        dispatch(getPosPropertyValueData(payloadProps))?.unwrap()?.then((res) => {
            if (res) {
                let discRestrictionArr: RestrictionData[] = [];
                res?.propertyValueData?.map((item: PropertyValueData) => {
                    item?.code === "DISCOUNT_RESTRICTION_VALUES" && item.propertyValues?.map((values: PropertyValues) => {
                        discRestrictionArr.push({ id: values?.id, label: values?.value, value: values?.value, code: values?.code })
                        setRestriction(discRestrictionArr)
                    })
                    if (item?.code === "APPLICABLE_CUSTOMERS") {
                        let APPLICABLE_CUSTOMERS: DropDownData[] = []
                        let customerData: eligibleCustomerDataType = new Map()
                        item?.propertyValues?.map((val) => {
                            if (!customerData?.has(val?.id?.toString()) && val?.value !== "For All") {
                                customerData.set(val.id?.toString(), { value: [], name: val?.value === "Customer Type" ? "Roles" : val?.value, code: val?.code })
                            }
                            APPLICABLE_CUSTOMERS.push({ code: val?.code, label: val?.value === "Customer Type" ? "Roles" : val?.value, value: val?.id.toString(), id: val?.id })
                        })
                        setTypesOfEligibility(APPLICABLE_CUSTOMERS)
                        setEligibileCustomersArr(customerData)
                    }

                    if (item?.code === "APPLICABLE_TO") {
                        item?.propertyValues?.map((values: PropertyValues) => {
                            if (values?.code == "ORDER") {
                                setApplicableTo(values?.id);
                            }
                        })
                    }
                })
                if (params?.discountId) {//if edit id exists
                    getOneDiscount()
                }
                !params?.discountId && setLoad(false)
            }

        }).catch((err) => {
            console.log('Error in getAllPropertyValues', err)
        })
    }

    //function to fetch single Discount details
    const getOneDiscount = () => {
        setLoad(true);
        let props = { storeId: config?.storeId, discountId: params?.discountId }
        dispatch(getOnePosDiscountData(props))?.unwrap()?.then((res) => {
            if (res && res?.discount) {
                setDiscountData(res?.discount);
                if (res?.discount?.promoCode === null) {
                    setIsDiscountAvailable(false)
                }

            }
            if (res?.discount?.endDate != null) {
                if (moment(res?.discount?.endDate).endOf('day').toDate() < moment(new Date()).endOf('day').toDate()) {
                    setDiscountExpired(true)
                }
            }
        }).catch((err) => {
            console.log('Error in getOneDiscount', err)
        }).finally(() => {
            setTimeout(() => { setLoad(false) }, 2000)
        })
    }

    // method to perform the validation
    const validationSchema = Yup.object().shape({
        promoCode: Yup.string()
            .label('promoCode')
            .required('Promo Code is required.'),
        discountType: Yup.number()
            .label('Discount Type')
            .required('Discount Type is required'),
        discountValue: Yup.number()
            .when("discountType", (discountTypeId) => {
                if (discountType?.find((i: DiscountTypeData) => i?.value == discountTypeId[0])?.label == 'Percentage') {
                    return Yup.number()
                        .label('discountValue')
                        .required("Discount value is required")
                        .typeError('Discount value accepts only numbers')
                        .min(1, "Discount value should be starts from 1")
                        .max(100, "Discount value should not exceed 100")
                }
                else {
                    return Yup.number()
                        .label('discountValue')
                        .required("Discount value is required")
                        .typeError('Discount value accepts only numbers')
                        .min(0.1, "Discount value should be starts from 0.1")
                        .max(10000, "Discount value should not exceed 10000")
                        .test('Decimal validation', 'Discount value accepts upto two decimal places', (val) => {
                            if (String(val).match(/^[0-9]+([.][0-9]{1,2})*$/))
                                return true
                        })
                }
            }),
        maxDiscountVal: Yup.string().label('maxDiscountVal')
            .nullable()
            .matches(/^\d+(\.\d+)?$/, 'Maximum Discount value accepts only numbers')
            .test('error msg on minimum zero or Maximum 10000', 'Maximum discount value should range from 0.1 to 10000', (val: any) => {
                return !(parseFloat(val) > 10000 || parseFloat(val) < 0.1);
            })
            .matches(/^\d{1,3}([.]\d{1,2}){0,1}$/, 'Tax percentage accept upto 2 decimal places only'),
        desc: Yup.string().label('desc').max(250, 'Description should not exceed 250 characters'),
        usagelimits: Yup.number().label('usagelimits')
            .nullable()
            .max(1000, 'Total usage limits should not exceed 1000')
            .min(1, "Total usage limit should range from 1 to 1000")
            .integer("Total usage limits accepts only whole numbers.")
            .typeError('Total usage limits accepts only numbers.'),
        usagelimitpercustomer: Yup.number().label('usagelimitpercustomer').when('usagelimits', (limitVal) => {
            if (limitVal[0]) {//if total usage limit exists
                return Yup.number().integer('Usage limits per customer accepts only whole numbers.')
                    .typeError('Usage limits per customer only accept numbers')
                    .min(1, "Usage limits per customer should starts from 1")
                    .max(1000, 'Usage limits per customer should not exceed 1000.')
                    .test('checking', 'Usage limits per customer should not exceed the total usage limit.', (val: any) => val < 1000 ? limitVal >= val : true)
            }
            else {
                return Yup.number().label('usagelimitpercustomer')
                    .integer('Usage limits per customer accepts only whole numbers.')
                    .typeError('Usage limits per customer only accept numbers')
                    .min(1, "Usage limits per customer should starts from 1")
                    .max(1000, "Usage limits per customer should not exceed 1000.")
            }
        }),
        restrictionBasedOn: Yup.string(),
        restrictionVal: Yup.number().label('restrictionVal')
            .when('restrictionBasedOn', (restrictionOption: string[]) => {
                if (restrictionOption[0] === "Minimum purchase amount") {
                    return Yup.number()
                        .required('Restriction Value is required')
                        .min(0.01, 'Restriction value starts from 0.01')
                        .max(1000000, 'Restriction value should not exceed 1000000')
                        .typeError("Restriction value must be a number")
                        .test('Decimal validation', 'Discount value accepts upto two decimal places', (val) => {
                            if (String(val).match(/^[0-9]+([.][0-9]{1,2})*$/))
                                return true
                        })
                }
                else if (restrictionOption[0] === "Minimum quantity of items") {
                    return Yup.number()
                        .required('Restriction value is required')
                        .typeError("Amount Limit must be a number")
                        .integer('Restriction value accepts only whole numbers.')
                        .min(1, 'Restriction value starts from 1')
                        .max(1000, 'Restriction value should not exceed 1000')
                        .typeError("Restriction value must be a number")
                }
                return Yup.mixed().notRequired().nullable()
            }),

        customerEligibilityType: Yup.string(),
        eligibility: Yup.array().label('eligibility')
            .when("customerEligibilityType", (eligibleType: string[]) => {
                let customerType = eligibileCustomersArr.get(eligibleType[0])?.name
                if (customerType === "Customer Group" || customerType === "Customers" || customerType === "Customer Type") {
                    return Yup.array()
                        .required('Customer Eligibility is required')
                        .min(1, 'Minimum 1 Customer Eligibility is required');
                }
                return Yup.array().nullable();
            }),

        startDate: Yup.date().label('startDate'),
        endDate: Yup.date()
            .when("startDate", (startDate) => {
                if (startDate[0]) {
                    return Yup.date().test("checkDate", 'End date is invalid', val => val ? moment(val).isAfter(startDate[0]) : true)
                }
                else {
                    return Yup.date()
                        .label('endDate')
                }
            })
    })

    //formik values
    const formik = useFormik({
        initialValues: {
            promoCode: discountData?.promoCode ? discountData?.promoCode : '',
            applicableTo: null,
            discountType: discountData?.discountTypeId ? discountData?.discountTypeId : discountType?.find((i: DiscountTypeData) => i?.code == "PERCENTAGE")?.value,
            discountValue: discountData?.discountValue && parseFloat(discountData?.discountValue) > 0 ? String(parseFloat(discountData?.discountValue)) : '',
            maxDiscountVal: discountData?.maxAmount ? String(discountData?.maxAmount) : null,
            desc: discountData?.description ? discountData?.description : '',
            isActive: params?.discountId ? discountData?.isActive : true,
            // isHidden: discountData?.isHidden != null ? discountData?.isHidden : null,
            restrictionBasedOn: params?.discountId ? discountData?.restrictionBasedOn ? restriction?.find((val: RestrictionData) => val?.id == discountData?.restrictionBasedOn)?.value : restriction?.find((val: RestrictionData) => val?.code == "NONE")?.value : restriction?.find((val: RestrictionData) => val?.code == "NONE")?.value,
            restrictionVal: discountData?.minValue ? discountData?.minValue : '',
            usagelimits: discountData?.overallUsageLimit ? String(discountData?.overallUsageLimit) : '',
            usagelimitpercustomer: discountData?.userBasedMaxUse ? String(discountData?.userBasedMaxUse) : '',
            startDate: params?.discountId ? discountData?.startDate != undefined ? discountData?.startDate : '' : useMemo(() => new Date(), []),
            endDate: discountData?.endDate ? discountData?.endDate?.toString() : '',
            customerEligibilityType: params?.discountId ? discountData?.customerEligibilityType ? typesOfEligibility?.find((val: customerEligibilityData) => val.id == discountData?.customerEligibilityType)?.value : typesOfEligibility?.find((val: customerEligibilityData) => val.label == 'For All')?.value : typesOfEligibility?.find((val: customerEligibilityData) => val.label == 'For All')?.value,
            eligibility: params?.discountId ? getEligiblityData() : []
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            setLoad(true); addDiscount(values);
        },
        enableReinitialize: true,
        validateOnChange: true
    })

    useEffect(() => {
        const backHandler = BackHandler.addEventListener('hardwareBackPress', () => {
            if (formik?.dirty) {
                setDirtyPopover(true)
                return true
            }
            else {
                navigation.goBack()
            }
            return true
        });
        return () => backHandler?.remove()
    }, [formik?.values])

    function getEligiblityData() {
        let data = []
        const roleDiscountMappings = discountData?.discountMappings?.roleDiscountMappings;
        const customerGroupDiscountMappings = discountData?.discountMappings?.customerGroupDiscountMappings;
        const customerDiscountMappings = discountData?.discountMappings?.customerDiscountMappings;
        if (roleDiscountMappings?.length) {
            data = roleDiscountMappings
        }
        else if (customerGroupDiscountMappings?.length) {
            data = customerGroupDiscountMappings
        }
        else if (customerDiscountMappings?.length) {
            data = customerDiscountMappings
        }
        return data;
    }

    //useEffect to handle selected typesOfEligibility values
    useEffect(() => {
        if (formik?.values?.customerEligibilityType && eligibileCustomersArr?.has(formik?.values?.customerEligibilityType)) {
            let apiVersion: "v1" | "v2" = "v2"
            const data = { isDiscount: true, isActive: true, issueCard: true }
            let { code, value } = eligibileCustomersArr?.get(formik?.values?.customerEligibilityType)!!

            if (!value?.length) {
                let url = API.eligibleCustomer
                if (code === "CUSTOMERS") {
                    url += 'name'
                } else if (code === "CUSTOMER_GROUP") {
                    url += 'group'
                } else if (code === "ROLE_BASED") {
                    url = `stores/{storeId}/roles`
                }
                dispatch(getCustomerEligibilityTypeData({ url, data: data, storeId: config.storeId, apiVersion }))?.unwrap()?.then((res) => {
                    if (res) {
                        let response: { name?: string, groupName: string, id: number }[] = res?.customergroup?.rows || res?.roles?.rows || res?.customers || []
                        if (!response?.length) {
                            ZenToast({ message: `${code} is empty, Choose any other eligibility type`, type: "warning" })
                            formik.setFieldValue('customerEligibilityType', '');
                        }

                        const customersVal = response?.map((e) => ({ label: e?.name || e?.groupName, value: e?.id, id: e?.id }));
                        setEligibileCustomersArr((prev) => {
                            let data = prev
                            if (data?.has(formik?.values?.customerEligibilityType)) {
                                let { code, name } = data.get(formik?.values?.customerEligibilityType)!!
                                data.set(formik?.values?.customerEligibilityType, { code, name, value: [...customersVal] })
                            }
                            return new Map(data)
                        })

                    }
                })
            }
        }
    }, [formik?.values?.customerEligibilityType])

    //useEffect to check duplicate promocode
    useEffect(() => {
        if (formik?.values?.promoCode != '' && !params?.discountId) {
            const duplicateDebounceFunction = setTimeout(() => {
                checkDuplicate(formik?.values?.promoCode)
            }, 1000)
            return () => clearTimeout(duplicateDebounceFunction)
        }
    }, [formik?.values?.promoCode])

    //function to checkDuplicate 
    const checkDuplicate = async (name: string) => {
        let payload = {
            storeId: config?.storeId,
            data: { promoCode: name }
        }
        await dispatch(checkDuplicatesData(payload)).unwrap().then((duplicateResponse) => {
            if (duplicateResponse) {
                setIsExist(duplicateResponse?.exist?.alreadyExist)
            }
        })
    }

    const checkAnyChanges = (val: any, currentData: any, eligiblitycode: string) => {
        if (val?.customerEligibilityType !== discountData?.customerEligibilityType?.toString()) {
            return true
        }
        else if (!eligiblitycode) {
            return true
        }
        else {
            let prevData = []
            if (eligiblitycode === "CUSTOMER_GROUP") {
                prevData = discountData?.discountMappings?.customerGroupDiscountMappings
            } else if (eligiblitycode === "CUSTOMERS") {
                prevData = discountData?.discountMappings?.customerDiscountMappings
            } else if (eligiblitycode === "ROLE_BASED") {
                prevData = discountData?.discountMappings?.roleDiscountMappings
            }
            if (prevData?.length !== currentData?.length) {
                return true
            }
            else {
                let result = currentData?.every((item: any) => prevData.includes(item))
                return !result
            }
        }
    }

    //function used to add & update discount
    const addDiscount = (val: any) => {
        const eligiblitycode = eligibileCustomersArr?.get(val?.customerEligibilityType)?.code || ""
        const eligibilityValue = val.eligibility

        const data = {
            storeId: config?.storeId,
            promoCode: val?.promoCode,
            discountValue: Number(val?.discountValue),
            discountTypeId: val?.discountType,
            startDate: val?.startDate ? moment(val?.startDate) : moment(),
            isPos: true,
            isWeb: false,
            medium: 'POS',
            isChangeEligibility: params?.discountId ? checkAnyChanges(val, eligibilityValue, eligiblitycode) : true,
            isManual: true,
            appliesTo: applicableTo ? applicableTo : null,
            minValue: val?.restrictionVal ? val?.restrictionVal : null,
            maxAmount: val?.maxDiscountVal ? val?.maxDiscountVal : null,
            overallUsageLimit: val?.usagelimits ? val?.usagelimits : null,
            userBasedMaxUse: val?.usagelimitpercustomer ? val?.usagelimitpercustomer : null,
            endDate: val?.endDate ? moment(val?.endDate) : null,
            isActive: val?.isActive,
            // isHidden: val?.isHidden,
            description: val?.desc ? val?.desc : null,
            customerEligibilityType: val?.customerEligibilityType || null,
            toAll: eligiblitycode === "" ? true : false,
            customerGroupDiscountMapping: eligiblitycode == "CUSTOMER_GROUP" ? eligibilityValue : null,
            customerDiscountMapping: eligiblitycode == "CUSTOMERS" ? eligibilityValue : null,
            roleDiscountMapping: eligiblitycode == "ROLE_BASED" ? eligibilityValue : null,
            restrictionBasedOn: restriction?.find((i: RestrictionData) => i?.label == val?.restrictionBasedOn)?.id,
        }
        if (params?.discountId) {
            dispatch(updatePosDiscount({ storeId: config?.storeId, data: data, id: params?.discountId }))?.unwrap()?.then((res) => {
                if (res) {
                    setLoad(false);
                    setTimeout(() => { ZenToast({ type: 'success', message: 'Manual discount created successfully' }) }, 50)
                    navigation?.goBack();
                }
            }).catch((err) => { console.log('Error in update discount', err) })
        }
        else {
            dispatch(addPosDiscount({ storeId: config?.storeId, data: data }))?.unwrap()?.then((res) => {
                if (res) {
                    setLoad(false);
                    setTimeout(() => { ZenToast({ type: 'success', message: 'Manual discount created successfully' }) }, 50)
                    navigation?.goBack()
                }
            }).catch((err) => { console.log('Error in add discount', err) })
        }
    }

    //method to perform the onConfirm functionality
    const onDateConfirm = (date: Date) => {
        if (startDateSelected) {
            formik.setFieldValue('startDate', moment(date))
        }
        else {
            formik?.setFieldValue('endDate', moment(date))
            setDiscountExpired(false);
        }
        setShowDate(false)
    }

    const getAllLabelValue = (dropdownVal: any) => {
        if (!dropdownVal?.length) {
            return ""
        }
        let result = dropdownVal?.map((item: any) => {
            let currData = eligibileCustomersArr.get(formik?.values?.customerEligibilityType)?.value?.find((val) => val?.id === item)
            return currData?.label
        })
        return result.join(",")
    }
    const showMaxDiscount =
        discountType.find((i) => i.value === formik?.values?.discountType)?.label === "Percentage";
    const showCustomerEligibility = eligibileCustomersArr.get(formik?.values?.customerEligibilityType)?.value?.length;


    useEffect(() => {
        if (formik?.values?.restrictionBasedOn) {
            formik?.setFieldTouched('restrictionVal', true);
            const restrictionId = (restriction?.find((i: RestrictionData) => i?.label === formik?.values?.restrictionBasedOn))?.id
            if (discountData?.restrictionBasedOn == restrictionId) {
                formik.setFieldValue('restrictionVal', discountData?.minValue)
            }
            else {
                formik.setFieldValue('restrictionVal', '');
            }
            setIsOptionChanged(false)
        }
    }, [formik?.values?.restrictionBasedOn])

    useEffect(() => {
        if (formik?.values?.customerEligibilityType) {
            formik.setFieldTouched('eligibility', true)
            if (discountData?.customerEligibilityType.toString() === formik?.values?.customerEligibilityType) {
                formik.setFieldValue('eligibility', getEligiblityData())
            }
            else {
                formik.setFieldValue('eligibility', [])
            }
            setIsOptionChanged(false)
        }

    }, [formik?.values?.customerEligibilityType])


    const isDisabled = useMemo(() => {

        if ((!formik?.isValid || !formik?.dirty) || isOptionChanged || isExist || discountExpired || Object?.keys(formik?.errors)?.length > 0) {
            return true
        }

        return false
    }, [formik?.isValid, formik?.dirty, , isOptionChanged, isExist, discountExpired, formik?.errors])

    return (
        <ThemeConsumer>
            {({ theme }) => (
                <KeyboardAvoidingView behavior={Platform.OS === 'ios' ? 'padding' : undefined} enabled style={theme?.manualDiscountStyle?.container}>
                    <CommonHeader headerName={params?.discountId ? `${isWrite ? "Edit" : "View"} Manual Discount` : "Add Manual Discount"} backIcon backIconOnpress={() => { formik?.dirty ? setDirtyPopover(true) : navigation?.goBack() }} />
                    <View style={{ flex: 1 }}>
                        <View style={{
                            flexDirection: "row", justifyContent: "space-between",
                            alignSelf: !isDiscountAvailable ? 'auto' : 'flex-end',

                        }}>
                            {!isDiscountAvailable && (
                                <View style={{
                                    backgroundColor: '#FFE5E5',
                                    paddingHorizontal: 10,
                                    paddingVertical: 5,
                                    borderRadius: 6,
                                    margin: 10
                                }}>
                                    <ZenText content={"This discount is currently not available"} bold style={{
                                        color: appColors?.red,
                                        marginVertical: 10, fontSize: fontSize.smallFontSize
                                    }} />
                                </View>
                            )}
                            <View style={theme?.manualDiscountStyle?.buttonView}>

                                {isWrite && <ZenButton title={discountData ? "Update" : "Save"}
                                    disabled={isDisabled}
                                    disabledStyle={{ borderColor: 'transparent' }}
                                    onPress={formik?.handleSubmit}
                                    titleStyle={{ fontSize: fontSize.tinyFontSize, color: appColors.light }}
                                    buttonStyle={{
                                        backgroundColor: appColors?.primary,
                                        borderRadius: 10,
                                        paddingHorizontal: 15,
                                        borderColor: 'transparent',
                                        borderWidth: 1
                                    }}
                                    containerStyle={{ borderRadius: 10, }}
                                />}
                            </View>
                        </View>

                        {
                            load ?
                                < View style={{ flex: 1, alignItems: "center", justifyContent: "center", marginVertical: 240 }}>
                                    <ZenLoader viewStyle={{ backgroundColor: "transparent" }} color={appColors?.primary} lottieType="Local" lottie={require('../../../assets/infinityLoader.json')} />
                                </View> :
                                <ScrollView showsVerticalScrollIndicator={false} >
                                    <View style={{ flex: 1, gap: 10, marginBottom: 10 }}>
                                        <View style={{ backgroundColor: appColors.light, marginHorizontal: 10, borderRadius: 10, paddingHorizontal: 10, }}>
                                            <ZenText content={"Basic Info"} style={theme?.manualDiscountStyle?.subHeading} />
                                            <View style={{ flexDirection: "row", flex: 1, gap: 25 }}>
                                                <ZenInput
                                                    value={formik?.values?.promoCode}
                                                    onChangeText={() => { }}
                                                    editable={false}
                                                    label={"Promo Code *"}
                                                    labelStyle={theme?.manualDiscountStyle?.labelStyle}
                                                    inputStyle={{ fontSize: fontSize?.tinyFontSize, color: params?.discountId ? appColors?.labelColor : appColors?.dark, fontFamily: appFonts?.medium }}
                                                    rightIcon={params?.discountId ? <ZenIcon name={"autorenew"} type="material-community" size={isLandscape ? 25 : 18} disabled={!isDiscountAvailable} color={appColors?.grey} />
                                                        :
                                                        <TouchableOpacity onPress={() => {
                                                            const len = 6; const char = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
                                                            const result = Array.from({ length: len }, () => char.charAt(Math.floor(Math.random() * char.length))).join('');
                                                            formik.setFieldValue('promoCode', result);
                                                        }}>
                                                            <ZenIcon name={"autorenew"} type="material-community" size={isLandscape ? 25 : 18} color={appColors?.grey} />
                                                        </TouchableOpacity>}
                                                    type="outlined"
                                                    containerStyle={{ flex: 1 }}
                                                    inputContainerStyle={{ paddingHorizontal: 8, height: 45 }}
                                                    errorMessage={formik?.touched?.promoCode && formik?.errors?.promoCode ? formik?.errors?.promoCode as string : ""}
                                                    errorStyle={{ color: 'red', fontFamily: appFonts.medium, fontSize: fontSize.errorFontSize }}
                                                />
                                                <View style={{ flexDirection: "column", flex: 1 }} >
                                                    <ZenText content='Discount Type *' style={{ fontFamily: appFonts.medium, fontSize: fontSize.tinyFontSize, color: appColors.grey }} />
                                                    <ZenDropdown
                                                        items={discountType}
                                                        open={dropdownOpen}
                                                        setOpen={setDropdownOpen}
                                                        value={formik?.values?.discountType}
                                                        setValue={() => { }}
                                                        multiple={false}
                                                        dropdownDirection='BOTTOM'
                                                        disabled={discountExpired || !isDiscountAvailable || !isWrite ? true : false}
                                                        labelStyle={{ fontSize: fontSize.tinyFontSize, color: appColors.dark, fontFamily: appFonts.medium, }}
                                                        placeholderStyle={{ color: appColors.grey, fontFamily: appFonts.medium, fontSize: fontSize.tinyFontSize, }}
                                                        style={{ height: 46 }}
                                                        selectedItemLabelStyle={{ fontSize: fontSize.tinyFontSize, fontFamily: appFonts.medium }}
                                                        containerStyle={{ marginTop: 5 }}
                                                        onPress={() => { formik?.setFieldTouched('discountType', true) }}
                                                        onSelectItem={(item) => {
                                                            formik?.setFieldValue('discountType', item?.value)
                                                        }}
                                                    />

                                                </View>

                                            </View>
                                            <View style={{ flexDirection: "row", flex: 1, gap: 25 }}>

                                                <ZenInput
                                                    value={formik?.values?.discountValue}
                                                    onChangeText={(txt) => { formik.setFieldValue('discountValue', txt) }}
                                                    label={"Discount Value *"}
                                                    labelStyle={theme?.manualDiscountStyle?.labelStyle}
                                                    inputStyle={theme?.manualDiscountStyle?.labelStyle}
                                                    keyboardType="numeric"
                                                    type="outlined"
                                                    disabled={discountExpired || !isDiscountAvailable || !isWrite ? true : false}
                                                    disabledInputStyle={{}}
                                                    containerStyle={{ flex: showMaxDiscount ? 0.5 : 0.49, }}
                                                    inputContainerStyle={{ paddingHorizontal: 8, height: 45 }}
                                                    onBlur={() => { formik.setFieldTouched('discountValue', true); formik.setFieldValue('discountValue', formik?.values?.discountValue?.trim()) }}
                                                    errorMessage={formik.touched.discountValue && formik.errors.discountValue ? formik.errors.discountValue : ""}
                                                    errorStyle={{ color: 'red', fontFamily: appFonts.medium, fontSize: fontSize.errorFontSize }}
                                                />
                                                {showMaxDiscount ?
                                                    <ZenInput
                                                        disabled={discountExpired || !isDiscountAvailable || !isWrite ? true : false}
                                                        value={formik?.values?.maxDiscountVal || ""}
                                                        onChangeText={(text) => formik.setFieldValue('maxDiscountVal', text)}
                                                        label={!isLandscape ? "Max Discount Value" : "Maximum Discount Value"}
                                                        labelStyle={theme?.manualDiscountStyle?.labelStyle}
                                                        inputStyle={theme?.manualDiscountStyle?.inputStyle}
                                                        keyboardType="numeric"
                                                        type="outlined"
                                                        containerStyle={{ flex: 0.5 }}
                                                        inputContainerStyle={{ paddingHorizontal: 8, height: 45 }}
                                                        onBlur={() => { formik?.setFieldTouched('maxDiscountVal', true); formik?.setFieldValue('maxDiscountVal', formik?.values?.maxDiscountVal?.trim()) }}
                                                        errorMessage={formik.touched.maxDiscountVal && formik.errors.maxDiscountVal ? formik.errors.maxDiscountVal : ""}
                                                        errorStyle={{ color: 'red', fontFamily: appFonts.medium, fontSize: fontSize.errorFontSize }}
                                                    /> : <></>}


                                            </View>
                                            <View style={{ flexDirection: "row", flex: 1, gap: 25 }}>
                                                <ZenInput
                                                    value={formik?.values?.desc}
                                                    onChangeText={(text) => formik.setFieldValue('desc', text)}
                                                    label={"Description"}
                                                    disabled={discountExpired || !isDiscountAvailable || !isWrite ? true : false}
                                                    labelStyle={theme?.manualDiscountStyle?.labelStyle}
                                                    inputStyle={theme?.manualDiscountStyle?.inputStyle}
                                                    type="outlined"
                                                    containerStyle={{ flex: 1 }}
                                                    inputContainerStyle={{ paddingHorizontal: 8, height: 45 }}
                                                    onBlur={() => { formik.setFieldTouched('desc', true); formik.setFieldValue('desc', formik?.values?.desc?.trim()) }}
                                                    errorMessage={formik.touched.desc && formik.errors.desc ? formik.errors.desc as string : ""}
                                                    errorStyle={{ color: 'red', fontFamily: appFonts.medium, fontSize: fontSize.errorFontSize }}
                                                />
                                                <View style={{ flexDirection: !isLandscape ? "column" : "row", flex: 1, gap: !isLandscape ? 10 : 25, justifyContent: "center", alignItems: "flex-start", }}>
                                                    <ZenCheckBox
                                                        title={'Enable'}
                                                        checked={formik?.values?.isActive}
                                                        disabled={discountExpired || !isDiscountAvailable || !isWrite ? true : false}
                                                        size={isLandscape ? 22 : 15}
                                                        containerStyle={{ alignSelf: "center" }}
                                                        titleStyle={theme?.manualDiscountStyle?.checkBoxText}
                                                        checkedColor={appColors.primary}
                                                        onPress={() => { formik?.setFieldValue('isActive', !formik?.values?.isActive) }}
                                                    />
                                                    {/* <ZenCheckBox
                                                        title={'Hide from store'}
                                                        checked={formik?.values?.isHidden}
                                                        disabled={discountExpired || !isDiscountAvailable || !isWrite ? true : false}
                                                        size={isLandscape ? 22 : 15}
                                                        containerStyle={{ alignSelf: "center" }}
                                                        titleStyle={theme?.manualDiscountStyle?.checkBoxText}
                                                        checkedColor={appColors.primary}
                                                        onPress={() => { formik?.setFieldValue('isHidden', !formik?.values?.isHidden) }}
                                                    /> */}
                                                </View>
                                            </View>
                                        </View>

                                        <View style={{ backgroundColor: appColors.light, marginHorizontal: 10, borderRadius: 10, paddingHorizontal: 10, }}>
                                            <ZenText content={"Discount Restriction"} style={theme?.manualDiscountStyle?.subHeading} />
                                            <View style={{ flexDirection: !isLandscape ? "column" : "row", flex: 1, gap: !isLandscape ? 10 : 25 }}>
                                                <View style={{ flexDirection: "row", flex: 1, gap: 25, alignItems: "flex-start", justifyContent: "flex-start" }}>
                                                    <ZenRadioButton
                                                        initialSelected={formik?.values?.restrictionBasedOn || ""}
                                                        options={restriction.map(opt => ({
                                                            ...opt,
                                                            disabled: discountExpired || !isDiscountAvailable || !isWrite
                                                        }))}
                                                        titleStyle={{ color: theme?.lightDark, fontSize: theme?.largerFontSize }}
                                                        containerStyle={{ flexDirection: "column", marginStart: 5, flex: 1, justifyContent: "space-between", flexWrap: "wrap" }}
                                                        onSelect={(value) => {
                                                            setIsOptionChanged(true)
                                                            formik.setFieldValue('restrictionBasedOn', value);
                                                        }}
                                                    />
                                                </View>
                                                {((restriction?.find((i: RestrictionData) => i?.label === formik?.values?.restrictionBasedOn))?.code !== 'NONE') &&
                                                    <ZenInput
                                                        value={formik?.values?.restrictionVal}
                                                        onChangeText={(txt) => { formik.setFieldValue('restrictionVal', txt) }}
                                                        label={"Restriction Value *"}
                                                        disabled={discountExpired || !isDiscountAvailable || !isWrite ? true : false}
                                                        labelStyle={theme?.manualDiscountStyle?.labelStyle}
                                                        inputStyle={theme?.manualDiscountStyle?.inputStyle}
                                                        type="outlined"
                                                        containerStyle={{ flex: 1 }}
                                                        inputContainerStyle={{ paddingHorizontal: 8, height: 45 }}
                                                        onBlur={() => { formik?.setFieldTouched('restrictionVal', true); }}
                                                        errorMessage={formik?.touched?.restrictionVal && formik?.errors?.restrictionVal ? formik?.errors?.restrictionVal as string : ""}
                                                        errorStyle={{ color: 'red', fontFamily: appFonts.medium, fontSize: fontSize.errorFontSize }}
                                                    />
                                                }
                                            </View>
                                            <View style={{ flexDirection: "row", flex: 1, gap: 25, marginTop: 5 }}>
                                                <ZenInput
                                                    value={formik?.values?.usagelimits}
                                                    onChangeText={(text) => formik.setFieldValue('usagelimits', text)}
                                                    label={"Total Usage limits"}
                                                    disabled={discountExpired || !isDiscountAvailable || !isWrite ? true : false}
                                                    labelStyle={theme?.manualDiscountStyle?.labelStyle}
                                                    inputStyle={theme?.manualDiscountStyle?.inputStyle}
                                                    type="outlined"
                                                    containerStyle={{ flex: 1 }}
                                                    inputContainerStyle={{ paddingHorizontal: 8, height: 45 }}
                                                    onBlur={() => { formik?.setFieldTouched('usagelimits', true); formik?.setFieldValue('usagelimits', formik?.values?.usagelimits) }}
                                                    rightIcon={
                                                        <ZenToolTip
                                                            height={50}
                                                            width={200}
                                                            backgroundColor={appColors?.lightBackgroundColor}
                                                            popoverStyle={{ elevation: 4 }}
                                                            content={<ZenText content='Number of times the discount is to be used' color={appColors.dark} size={fontSize.errorFontSize} />}
                                                            popover={<Pressable onPress={() => { }}>
                                                                <ZenIcon name="information" type="material-community" size={16} color={appColors?.primary} style={{ marginLeft: 5, marginTop: 7 }} />
                                                            </Pressable>}
                                                        />
                                                    }
                                                    errorMessage={formik?.touched?.usagelimits && formik?.errors?.usagelimits ? formik?.touched?.usagelimits && formik?.errors?.usagelimits : ""}
                                                    errorStyle={{ color: 'red', fontFamily: appFonts.medium, fontSize: fontSize.errorFontSize }}
                                                />
                                                <ZenInput
                                                    value={formik?.values?.usagelimitpercustomer}
                                                    onChangeText={(text) => formik.setFieldValue('usagelimitpercustomer', text)}
                                                    label={!isLandscape ? "Limits per customer" : "Usage limits per customer"}
                                                    disabled={discountExpired || !isDiscountAvailable || !isWrite ? true : false}
                                                    labelStyle={theme?.manualDiscountStyle?.labelStyle}
                                                    inputStyle={theme?.manualDiscountStyle?.inputStyle}
                                                    type="outlined"
                                                    keyboardType="numeric"
                                                    containerStyle={{ flex: 1 }}
                                                    inputContainerStyle={{ paddingHorizontal: 8, height: 45 }}
                                                    onBlur={() => { formik?.setFieldTouched('usagelimitpercustomer', true); formik?.setFieldValue('usagelimitpercustomer', formik?.values?.usagelimitpercustomer) }}
                                                    errorMessage={formik?.touched?.usagelimitpercustomer && formik?.errors?.usagelimitpercustomer ? formik?.touched?.usagelimitpercustomer && formik?.errors?.usagelimitpercustomer : ""}
                                                    errorStyle={{ color: 'red', fontFamily: appFonts.medium, fontSize: fontSize.errorFontSize }}
                                                />
                                            </View>
                                        </View>

                                        <View style={{ backgroundColor: appColors.light, marginHorizontal: 10, borderRadius: 10, paddingHorizontal: 10, }}>
                                            <ZenText content={"Schedule"} style={theme?.manualDiscountStyle?.subHeading} />
                                            <View style={{ flexDirection: "row", flex: 1, gap: 25 }}>
                                                <Pressable style={PayXGetFreeStyle.inputFlex} onPress={() => {
                                                    if (formik?.values?.startDate != '' && (moment(formik?.values?.startDate).endOf('day').toDate() > moment(new Date()).endOf('day').toDate())) {
                                                        setDate(new Date(formik?.values?.startDate))
                                                    }
                                                    else {
                                                        setDate(new Date());
                                                        formik.setFieldTouched('startDate', true);
                                                    }
                                                    setStartDateSelected(true)
                                                    setShowDate(!showDate);
                                                }} >

                                                    <ZenInput
                                                        value={formik?.values?.startDate != '' ? moment(new Date(formik?.values?.startDate))?.format('MM/DD/YYYY')?.toString() : ""}
                                                        onChangeText={(text) => formik.setFieldValue('startDate', text)}
                                                        label={"Start date"}
                                                        placeholder='MM/DD/YYYY'
                                                        editable={false}
                                                        labelStyle={theme?.manualDiscountStyle?.labelStyle}
                                                        inputStyle={theme?.manualDiscountStyle?.inputStyle}
                                                        type="outlined"
                                                        containerStyle={{ flex: 1 }}
                                                        inputContainerStyle={{ paddingHorizontal: 8, height: 45 }}
                                                        rightIcon={<ZenIcon name="calendar" type='material-community' size={20} color={appColors.grey} disabled={!isDiscountAvailable}
                                                        />}
                                                        errorMessage={formik.touched.startDate && formik.errors.startDate ? formik.errors.startDate as string : ""}
                                                        errorStyle={{ color: 'red', fontFamily: appFonts.medium, fontSize: fontSize.errorFontSize }}
                                                    />
                                                </Pressable>
                                                <Pressable style={PayXGetFreeStyle.inputFlex} onPress={() => {
                                                    if (formik?.values?.endDate != '' && (moment(formik?.values?.endDate).endOf('day').toDate() > moment(new Date()).endOf('day').toDate())) {
                                                        setDate(new Date(formik?.values?.endDate));
                                                    }
                                                    else {
                                                        setDate(new Date())
                                                    }
                                                    formik.setFieldTouched('endDate', true)
                                                    setStartDateSelected(false)
                                                    setShowDate(!showDate)

                                                }} >

                                                    <ZenInput
                                                        value={formik?.values?.endDate != '' ? moment(new Date(formik?.values?.endDate))?.format('MM/DD/YYYY')?.toString() : ""}
                                                        onChangeText={(text) => formik.setFieldValue('endDate', text)}
                                                        label={"End date"}
                                                        placeholder='MM/DD/YYYY'
                                                        editable={false}
                                                        labelStyle={theme?.manualDiscountStyle?.labelStyle}
                                                        inputStyle={theme?.manualDiscountStyle?.inputStyle}
                                                        type="outlined"
                                                        containerStyle={{ flex: 1 }}
                                                        inputContainerStyle={{ paddingHorizontal: 8, height: 45 }}
                                                        rightIcon={<ZenIcon name="calendar" size={20} type='material-community' color={appColors.grey} disabled={!isDiscountAvailable}
                                                        />}
                                                        errorMessage={formik.touched.endDate && formik.errors.endDate ? formik.errors.endDate as string : ""}
                                                        errorStyle={{ color: 'red', fontFamily: appFonts.medium, fontSize: fontSize.errorFontSize }}
                                                    />
                                                </Pressable>
                                            </View>
                                            {showDate &&
                                                <ZenDateTimePicker
                                                    date={mydate}
                                                    mode='date'
                                                    open={showDate}
                                                    onConfirm={(val) => { onDateConfirm(val); }}
                                                    minimumDate={startDateSelected ? new Date(moment().format("YYYY-MM-DD")) : (formik.values?.startDate ? new Date(formik.values?.startDate) : new Date(moment().format("YYYY-MM-DD")))}
                                                    maximumDate={startDateSelected && formik?.values?.endDate ? new Date(formik?.values?.endDate) : undefined}
                                                    onCancel={() => { setShowDate(false) }}
                                                />}
                                        </View>

                                        <View style={{ backgroundColor: appColors.light, marginHorizontal: 10, borderRadius: 10, paddingHorizontal: 10, }}>
                                            <ZenText content={"Customer Eligibility*"} style={theme?.manualDiscountStyle?.subHeading} />
                                            <View style={{ flexDirection: !isLandscape ? "column" : "row", flex: 1, gap: !isLandscape ? 10 : 25, marginBottom: 10 }}>
                                                <View style={{ flexDirection: "column", flex: showCustomerEligibility ? 1 : 0.5, marginRight: showCustomerEligibility ? 0 : 22, }} >
                                                    <ZenDropdown
                                                        items={typesOfEligibility}
                                                        open={eligibilityOpen}
                                                        setOpen={setEligibilityOpen}
                                                        title="Customer Eligibility Type"
                                                        value={formik?.values?.customerEligibilityType}
                                                        setValue={() => { }}
                                                        multiple={false}
                                                        dropdownDirection='TOP'
                                                        disabled={discountExpired || !isDiscountAvailable || !isWrite ? true : false}
                                                        labelStyle={{ fontSize: fontSize.tinyFontSize, color: discountExpired || !isWrite ? appColors?.grey : appColors.dark, fontFamily: appFonts.medium, }}
                                                        titleStyle={{ fontFamily: appFonts.medium, fontSize: fontSize.tinyFontSize, color: appColors.grey }}
                                                        style={{ height: 46 }}
                                                        selectedItemLabelStyle={{ fontSize: fontSize.tinyFontSize, fontFamily: appFonts.medium }}
                                                        containerStyle={{}}
                                                        onPress={() => { formik?.setFieldTouched('customerEligibilityType', true); }}
                                                        onSelectItem={(item) => {
                                                            setIsOptionChanged(true)
                                                            formik?.setFieldValue('customerEligibilityType', item?.value)
                                                        }}


                                                    />
                                                    {formik?.touched?.customerEligibilityType && formik?.errors?.customerEligibilityType &&
                                                        <ZenText content={formik?.errors?.customerEligibilityType as string} style={{ color: 'red', fontFamily: theme?.medium, fontSize: fontSize.errorFontSize }} />
                                                    }
                                                </View>
                                                {showCustomerEligibility ?
                                                    <View style={{ flexDirection: "column", flex: 1 }} >
                                                        <ZenText content={`Choose ${eligibileCustomersArr.get(formik?.values?.customerEligibilityType)?.name} *`} style={{ fontFamily: appFonts.medium, fontSize: fontSize.tinyFontSize, color: appColors.grey }} />
                                                        <ZenDropdown
                                                            items={eligibileCustomersArr.get(formik?.values?.customerEligibilityType)?.value!!}
                                                            open={customerGroupOpen}
                                                            setOpen={setCustomerGroupOpen}
                                                            value={formik?.values?.eligibility}
                                                            // multipleText={multipleCustomerGroup?.length > (isLandscape ? 60 : 22) ? multipleCustomerGroup.slice(0, isLandscape ? 60 : 22).concat('...').toString() : multipleCustomerGroup.toString()}
                                                            setValue={() => { }}
                                                            multipleText={getAllLabelValue(formik?.values?.eligibility)}
                                                            multiple={true}
                                                            searchable={true}
                                                            searchPlaceholder={`Search ${eligibileCustomersArr.get(formik?.values?.customerEligibilityType)?.name}`}
                                                            maxHeight={140}
                                                            dropdownDirection='TOP'
                                                            disabled={discountExpired || !isDiscountAvailable || !isWrite ? true : false}
                                                            labelStyle={{ fontSize: fontSize.tinyFontSize, color: appColors.dark, fontFamily: appFonts.medium, }}
                                                            placeholderStyle={{ color: appColors.grey, fontFamily: appFonts.medium, fontSize: fontSize.tinyFontSize, }}
                                                            style={{ height: 46 }}
                                                            selectedItemLabelStyle={{ fontSize: fontSize.tinyFontSize, fontFamily: appFonts.medium }}
                                                            containerStyle={{ marginTop: 5 }}
                                                            onClose={() => { formik.setFieldTouched('eligibility', true) }}

                                                            onSelectItem={(item) => {
                                                                formik.setFieldValue('eligibility', item?.map((val) => val?.id))
                                                            }}
                                                        />
                                                        {formik?.touched?.eligibility && formik?.errors?.eligibility &&
                                                            <ZenText content={formik?.errors?.eligibility as string} style={{ color: 'red', fontFamily: theme?.medium, fontSize: fontSize.errorFontSize }} />
                                                        }
                                                    </View> : <></>}
                                            </View>

                                        </View>
                                    </View>

                                </ScrollView>}

                        <Popover isVisible={dirtyPopover} popoverStyle={{ width: width > 900 ? 500 : isLandscape ? 450 : 350, borderRadius: 10 }}>
                            <CommonDialogBox type='EDIT' replaceValue="page" confirmation={confirmation} />
                        </Popover>
                        <Popover isVisible={expiredPopover} popoverStyle={{ width: width > 900 ? 500 : isLandscape ? 450 : 350, borderRadius: 10 }}>
                            <CommonDialogBox type='OTHER' dialog={warningDialogProps} confirmation={setWarningConfirmMessage} />
                        </Popover>
                    </View>
                </KeyboardAvoidingView>
            )}
        </ThemeConsumer>
    )
}
export default AddEditManual